/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")
	.controller( "OpenImportsCtrlParameters", ["$scope", "toastr", "Utils", "$uibModal", "OpenImportsService",
	function ($scope, toastr, Utils, $uibModal, OpenImportsService) {

		$scope.parameterList = [];
		$scope.data = {
			importParameters: {}
		};

		const parameterMapping = {
			"type": "Type",
			"name": "Non du Fichier",
			"splitCharacter": "Caractère de séparation",
			"quayIdPrefixToRemove": "Préfixe quai à supprimer",
			"distanceGeolocation": "Distance de mise à jour des points d'arrêts (en mètres)",
			"removeParentStations": "Suppression des parent stations",
			"routeMerge": "Fusion des lignes",
			"commercialPointIdPrefixToRemove": "Préfixe point commercial à supprimer",
			"areaCentroidPrefixToRemove": "Préfixe areaCentroid à supprimer",
			"stopAreaPrefixToRemove": "Préfixe stopArea à supprimer",
			"linePrefixToRemove": "Préfixe ligne à supprimer",
			"ignoreCommercialPoints": "Ignorer les points commerciaux",
			"cleanMode": "Mode d'import",
			"generateMapMatching": "Générer les tracés suite à l'import",
			"routesReorganization": "Optimisation des routes",
			"routeSortOrder": "Prendre en compte l'ordre dans lequel les lignes seront présentées aux usagers",
			"netexImportLayouts": "Importer les tracés",
			"netexImportColors": "Importer les couleurs",
			"keepStopNames": "Conservation des noms d'arrêt",
			"keepStopGeolocalisation": "Conservation de la géolocalisation des arrêts",
			"keepBoardingAlighting": "Conservation des TAD",
			"importShapesFile": "Import du fichier shapes.txt",
			"updateStopAccessibility": "Mise à jour de l'accessibilité des arrets",
			"description": "Description",
			"useTargetNetwork": "Importer sur un réseau spécifique",
			"targetNetwork": "Nom du réseau ciblé",
			"renameRoutesAfterMerge": "Renommer les routes après optimisation",
			"importFareFiles": "Conserver les fichiers GTFS Fare v1",
			"recomputeStopPlacesLocation": "Recalculer la position des stop places",
			"importTargetRoutes": "Intégrer seulement certains route_id",
			"allowNonStandardGtfs": "Autoriser un GTFS non standard",
			"fillMissingStopName": "Remplir les noms d'arrêts absents",
			"fillMissingCoordinates": "Remplir les arrêts sans coordonnées GPS",
			"overwriteLineInformation": "Ecraser les informations des lignes",
			"allowGtfsFlex": "Importer les fichiers flex",
			"externalRefField": "Champ du fichier trips.txt pour alimenter la key value 'external-ref'",
			"driverControllerCodeField": "Champ du fichier trips.txt pour alimenter la key value 'driver-controller-code'",
		};

		let feedActionParameter = function () {
			OpenImportsService.getActionParameters($scope.referential, $scope.id)
				.then((response) => {
					const data = response.data;
					let parameters;
					if (data["gtfs-import"]) {
						parameters = data["gtfs-import"];
						actionParametersCommun(parameters);
						$scope.data.importParameters.type = "Gtfs";
						$scope.data.importParameters.name = parameters.name;
						$scope.data.importParameters.splitCharacter = parameters.split_character;
						$scope.data.importParameters.quayIdPrefixToRemove = parameters.quay_id_prefix_to_remove;
						$scope.data.importParameters.linePrefixToRemove = parameters.line_prefix_to_remove;
						$scope.data.importParameters.commercialPointIdPrefixToRemove = parameters.commercial_point_prefix_to_remove;
						$scope.data.importParameters.distanceGeolocation = parameters.distance_geolocation;
						$scope.data.importParameters.removeParentStations = parameters.remove_parent_stations;
						$scope.data.importParameters.routeMerge = parameters.route_merge;
						$scope.data.importParameters.importShapesFile =  parameters.import_shapes_file;
						$scope.data.importParameters.updateStopAccessibility = parameters.update_stop_accessibility;
						$scope.data.importParameters.useTargetNetwork = parameters.use_target_network;
						$scope.data.importParameters.targetNetwork = parameters.target_network;
						$scope.data.importParameters.renameRoutesAfterMerge = parameters.rename_routes_after_merge;
						$scope.data.importParameters.importFareFiles = parameters.import_fare_files;
						$scope.data.importParameters.importTargetRoutes = parameters.import_target_routes;
						$scope.data.importParameters.allowNonStandardGtfs = parameters.allow_non_standard_gtfs;
						$scope.data.importParameters.fillMissingStopName = parameters.fill_missing_stop_name;
						$scope.data.importParameters.fillMissingCoordinates = parameters.fill_missing_coordinates;
						$scope.data.importParameters.overwriteLineInformation = parameters.overwrite_line_information;
						$scope.data.importParameters.routeSortOrder = parameters.route_sort_order;
						$scope.data.importParameters.allowGtfsFlex = parameters.allow_gtfs_flex;
						$scope.data.importParameters.externalRefField = parameters.external_ref_field;
						$scope.data.importParameters.driverControllerCodeField = parameters.driver_controller_code_field;
					}
					if (data["neptune-import"]) {
						parameters = data["neptune-import"];
						actionParametersCommun(parameters);
						$scope.data.importParameters.type = "Neptune";
						$scope.data.importParameters.name = parameters.name;
						$scope.data.importParameters.areaCentroidPrefixToRemove = parameters.areaCentroid_prefix_to_remove;
						$scope.data.importParameters.stopAreaPrefixToRemove = parameters.stopArea_prefix_to_remove;
						$scope.data.importParameters.linePrefixToRemove = parameters.line_prefix_to_remove;
						$scope.data.importParameters.ignoreCommercialPoints = parameters.ignore_commercial_points;
					}
					if (data["netexprofile-import"]) {
						parameters = data["netexprofile-import"];
						actionParametersCommun(parameters);
						$scope.data.importParameters.type = "Netex Profile";
						$scope.data.importParameters.name = parameters.name;
						$scope.data.importParameters.useTargetNetwork = parameters.use_target_network;
						$scope.data.importParameters.targetNetwork = parameters.target_network;
						$scope.data.importParameters.netexImportLayouts = parameters.netex_import_layouts;
						$scope.data.importParameters.netexImportColors = parameters.netex_import_colors;
					}
					feedParametersList();
				});
		};

		let actionParametersCommun = function (parameters){
			$scope.data.importParameters.description = parameters.description;
			$scope.data.importParameters.cleanMode = translateCleanMode(parameters.clean_mode);
			//$scope.data.importParameters.generateMapMatching = parameters.generate_map_matching;
			$scope.data.importParameters.routesReorganization = parameters.routes_reorganization;
			$scope.data.importParameters.keepStopNames = parameters.keep_stop_names;
			$scope.data.importParameters.keepBoardingAlighting = parameters.keep_boarding_alighting;
			$scope.data.importParameters.keepStopGeolocalisation = parameters.keep_stop_geolocalisation;
			$scope.data.importParameters.generateMapMatching = translateMapMatchingMode(parameters.generate_map_matching);
			$scope.data.importParameters.recomputeStopPlacesLocation = parameters.recompute_stop_places_location;
		};

		let translateCleanMode = function (mode){
			if (mode === "contiguous"){
				return "Contigu";
			} else if (mode === "overlap") {
				return "Complément";
			} else if (mode === "purge"){
				return "Purge";
			}
		};

		let translateMapMatchingMode = function (mode){
			if (mode === "NONE" || mode === "false"){
				return "Non";
			} else if (mode === "CAR" || mode === "true") {
				return "Oui - Selon le tracé routier";
			} else if (mode === "AIR"){
				return "Oui - A vol d'oiseau";
			}
		};

		let feedParametersList = function () {
			for (let paramName in $scope.data.importParameters) {
				if ($scope.data.importParameters.hasOwnProperty(paramName)) {
					let parameterValue = $scope.data.importParameters[paramName];
					if (typeof parameterValue === "boolean") {
						parameterValue = parameterValue ? "Oui" : "Non";
					} else if (parameterValue === "true" || parameterValue === "false") {
						parameterValue = parameterValue === "true" ? "Oui" : parameterValue === "false" ? "Non" : "";
					} else if (parameterValue === "null") {
						parameterValue = "";
					}

					let comment = parameterMapping[paramName] || paramName;

					let existingParameter = $scope.parameterList.find(p => p.paramName === comment);
					if (existingParameter) {
						if (parameterValue !== undefined && parameterValue !== null && parameterValue !== "") {
							existingParameter.paramValue = parameterValue;
						}
					} else {
						$scope.parameterList.push({ paramName: comment, paramValue: parameterValue });
					}
				}
			}
		};

		feedActionParameter();
	}]);